var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('te',{attrs:{"data":[{label: '1', key: 1}, {label: 2, key: 2}]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }